import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { VisuallyHidden } from '@change-corgi/design-system-legacy/a11y';
import { iconLock } from '@change-corgi/design-system-legacy/icons';

import { useIsSunriseEnabled } from '../../hooks/isSunriseEnabled';
import { ShareContainer } from '../share';
import { SignatureStatsClosedContainer } from '../stats/signatureStats';

import { SidePetitionStatus } from './components/SidePetitionStatus';

export const SideClosedContainer: React.FC = () => {
	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();

	return (
		<>
			<SidePetitionStatus
				icon={iconLock}
				iconColor={isSunriseEnabled ? '' : 'neutral-grey600'}
				customStyles={isSunriseEnabled ? { borderTop: '1px solid', borderRadius: '0' } : undefined}
			>
				<Translate value="fe.pages.petition_show.status.closed" />
			</SidePetitionStatus>
			<SignatureStatsClosedContainer />
			<VisuallyHidden as="h2">
				<Translate value="fe.components.petition_share.action" />
			</VisuallyHidden>
			<ShareContainer forMobileView={false} />
		</>
	);
};
